import * as service from './EvaluationManage.service'

export default {
  data() {
    return {
      Evaluationcolumns: ['Name', 'Description', 'Actions'],
      optionstable: {

        headings: {
          Name: 'Name',
          Description: 'Description',

          Actions: ''

        },
        sortIcon: {
          base: 'glyphicon',
          up: 'glyphicon-chevron-up',
          down: 'glyphicon-chevron-down'
        },
        sortable: [],
        orderBy: {
          column: 'Ordinance',
          ascending: true
        },
        texts: {

          filterPlaceholder: 'Filter...',
          limit: 'Records:',
          noResults: 'No matching records',

        },

      },

      Performancecolumns: ['Name', 'Description', 'Actions'],
      perfoptionstable: {

        headings: {
          Name: 'Name',
          Description: 'Description',

          Actions: ''

        },
        sortIcon: {
          base: 'glyphicon',
          up: 'glyphicon-chevron-up',
          down: 'glyphicon-chevron-down'
        },
        sortable: [],
        texts: {

          filterPlaceholder: 'Filter...',
          limit: 'Records:',
          noResults: 'No matching records',

        },

      },
      AddEvaluationForm: {
        'Name': '',
        'Description': '',
        'Ordinance': '',
        'IsActive': true
      },
      AddPerformanceForm: {
        'Name': '',
        'Description': '',
        'Ordinance': '',
        'IsActive': true
      },
      eordinance: [],
      pordinance: [],
      evaluationtypes: [],
      performancelevels: [],
      IsPerfEdit: false,
      IsEvalEdit: false,
      emodalTitle: '',
      pmodalTitle: '',
      IsAdding: false //FG - FOOF - After Cert - First Release (6) - force add to go to bottom of list hack for first release
    }
  },
  mounted() {

    this.GetAllEvaluationTypes()

    this.GetAllPerformanceLevels()

  },

  methods: {

    addEvaluation() {
      this.AddEvaluationForm = {
        'Name': '',
        'Description': '',
        'Ordinance': '',
        'IsActive': true
      }
      this.IsEvalEdit = false
      this.IsAdding = true; //FG - FOOF - After Cert - First Release (6) - force add to go to bottom of list hack for first release
      this.emodalTitle = 'Add Evaluation Type'
      $('#AddEvaluatemodel').modal('show')
      //this.AddEvaluationForm.Ordinance = this.eordinance[0] // COMMENTED OUT - //FG - FOOF - After Cert - First Release (6) - force add to go to bottom of list hack for first release
      //FG - FOOF - After Cert - First Release (6) - force add to go to bottom of list hack for first release below
      var newOrdinance = this.evaluationtypes[this.evaluationtypes.length-1].Ordinance + 1;
      this.AddEvaluationForm.Ordinance = newOrdinance;
      //FG - FOOF - After Cert - First Release (6) - force add to go to bottom of list hack for first release above
    },

    addPerformance() {
      this.AddPerformanceForm = {
        'Name': '',
        'Description': '',
        'Ordinance': '',
        'IsActive': true
      }
      this.IsPerfEdit = false
      this.IsAdding = true;//FG - FOOF - After Cert - First Release (6) - force add to go to bottom of list hack for first release
      this.pmodalTitle = 'Add Performance Level Type'
      $('#Performancemodel').modal('show')
      //this.AddPerformanceForm.Ordinance = this.pordinance[0] //Commented out - //FG - FOOF - After Cert - First Release (6) - force add to go to bottom of list hack for first release
      //FG - FOOF - After Cert - First Release (6) - force add to go to bottom of list hack for first release
      var newOrdinance = this.performancelevels[this.performancelevels.length-1].Ordinance + 1;
      this.AddPerformanceForm.Ordinance = newOrdinance;
      //FG - FOOF - After Cert - First Release (6) - force add to go to bottom of list hack for first release
    },

    cancelpopup: function () {
      this.IsCertificateTypeEdit = false
      $('#AddCertificatemodel').modal('hide')
    },

    editeval: function (data) {
      var ID = data.row.Id
      this.emodalTitle = 'Edit Evaluation Level Type'
      this.IsEvalEdit = true
      this.IsAdding = false;//FG - FOOF - After Cert - First Release (6) - force add to go to bottom of list hack for first release
      this.AddEvaluationForm = deepcopy(data.row)

      $('#AddEvaluatemodel').modal('show')

    },

    editperf: function (data) {
      var ID = data.row.Id
      this.pmodalTitle = 'Edit Performance Level Type'
      this.IsPerfEdit = true
      this.IsAdding = false;//FG - FOOF - After Cert - First Release (6) - force add to go to bottom of list hack for first release
      this.AddPerformanceForm = deepcopy(data.row)

      $('#Performancemodel').modal('show')

    },

    //FG - FOOF - After Cert - First Release (3) - Greatly simplified the method below so
    // rows would get sorted properly when ordinance was changed.
    ChangeEvaluationTypeOrdinance(res) {
      let context = this
      if(res) {
        if(res.Ordinance < res.OldOrdinance)
          res.Ordinance = res.Ordinance -.5;
        else 
            res.Ordinance = res.Ordinance + .5;
        this.evaluationtypes.sort(function(a,b){
          return a.Ordinance - b.Ordinance
        })
        for(var i=0;i<this.evaluationtypes.length;i++) {
          this.evaluationtypes[i].Ordinance = i+1;
        }
      }

      service.ChangeEvaluationTypeOrdinance(context.evaluationtypes).then(function (response) {
        
        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) { 
          loader.stopLoader()
          return;
        }
        
        loader.stopLoader()
        $('#AddEvaluatemodel').modal('hide')
        context.GetAllEvaluationTypes()
        //FG - FOOF - After Cert - First Release (6) - I added an eval type while testing the delete dialog
        //     and found that the busy icon didn't dissapear after adding an eval type so I added the line
        //     below to fix that.
        loader.stopLoader();
      }, (error) => {
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
        //FG - FOOF - After Cert - First Release (6) - I added an eval type while testing the delete dialog
        //     and found that the busy icon didn't dissapear after adding an eval type so I added the line
        //     below to fix that.
        loader.stopLoader();
      })
    },

    //FG - FOOF - After Cert - First Release (3) - Greatly simplified the method below so
    // rows would get sorted properly when ordinance was changed.
    ChangePerformanceLevelOrdinance(res) {
      let context = this
      if(res) {
        if(res.Ordinance < res.OldOrdinance)
          res.Ordinance = res.Ordinance -.5;
        else 
            res.Ordinance = res.Ordinance + .5;
        this.performancelevels.sort(function(a,b){
          return a.Ordinance - b.Ordinance
        })
        for(var i=0;i<this.performancelevels.length;i++) {
          this.performancelevels[i].Ordinance = i+1;
        }
      }
      service.ChangePerformanceLevelOrdinance(context.performancelevels).then(function (response) {
        loader.stopLoader()
        $('#Performancemodel').modal('hide')
        context.GetAllPerformanceLevels()
        //FG - FOOF - After Cert - First Release (6) - I added an eval type while testing the delete dialog
        //     and found that the busy icon didn't dissapear after adding an eval type so I added the line
        //     below to fix that.
        loader.stopLoader();
      }, (error) => {
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
        //FG - FOOF - After Cert - First Release (6) - I added an eval type while testing the delete dialog
        //     and found that the busy icon didn't dissapear after adding an eval type so I added the line
        //     below to fix that.
        loader.stopLoader();
      })

    },

    updateEval(formName) {
      let context = this

      this.$refs[formName].validate((valid) => {


        if (valid) {

          let context = this
          loader.startLoader()

          service.UpdateEvaluationType(context.AddEvaluationForm).then(function (response) {

            //Is this restricted ? -- FG - After Cert - First Release Security
            if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) { 
              loader.stopLoader()
              return;
            }

            loader.stopLoader()
            $('#AddEvaluatemodel').modal('hide')
            ///  context.GetAllEvaluationTypes()

            for (var i = 0; i < context.evaluationtypes.length; i++) {
              if (context.evaluationtypes[i].Id == response.Id) {
                context.evaluationtypes.splice(i, 1, response)
                //context.evaluationtypes.push(response)

                break
              }

            }



            context.ChangeEvaluationTypeOrdinance(response)


            context.$notify({

              title: 'Success',

              message: 'Evaluation Type  updated',

              type: 'success'

            })

          }, (error) => {

            loader.stopLoader()
            $('#AddEvaluatemodel').modal('hide')
            this.$notify({

              title: 'Error',

              message: error.responseJSON.Message,

              type: 'error'

            })
          })

        } else {
          this.$notify({

            title: 'Error',

            message: 'EVAL - 1 error while submit!!',

            type: 'error'

          })
          return false
        }
      })
    },

    updatePerformance(formName) {
      let context = this

      this.$refs[formName].validate((valid) => {


        if (valid) {

          let context = this
          loader.startLoader()

          service.UpdatePerformanceLevel(context.AddPerformanceForm).then(function (response) {

            //Is this restricted ? -- FG - After Cert - First Release Security
            if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) { 
              loader.stopLoader()
              return;
            }

            loader.stopLoader()
            $('#Performancemodel').modal('hide')

            for (var i = 0; i < context.performancelevels.length; i++) {
              if (context.performancelevels[i].Id == response.Id) {
                context.performancelevels.splice(i, 1, response)
                //context.evaluationtypes.push(response)

                break
              }

            }

            context.ChangePerformanceLevelOrdinance(response)

            context.$notify({

              title: 'Success',

              message: 'Performance Level  updated',

              type: 'success'

            })

          }, (error) => {

            loader.stopLoader()
            $('#Performancemodel').modal('hide')
            this.$notify({

              title: 'Error',

              message: error.responseJSON.Message,

              type: 'error'

            })
          })

        } else {
          this.$notify({

            title: 'Error',

            message: 'EVAL - 2 error while submit!!',

            type: 'error'

          })
          return false
        }
      })
    },

    submitPerformance(formName) {
      let context = this

      this.$refs[formName].validate((valid) => {


        if (valid) {

          let context = this
          loader.startLoader()

          service.AddPerformanceLevel(context.AddPerformanceForm).then(function (response) {

            //Is this restricted ? -- FG - After Cert - First Release Security
            if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) { 
              loader.stopLoader()
              return;
            }

            loader.stopLoader()
            $('#Performancemodel').modal('hide')
            context.GetAllPerformanceLevels()

            //FG - FOOF - After Cert - First Release Security... I don't see the need
            //  for the call to ChangePerformanceLevelOrdinance here and it messes with
            //  security checks.... I especially don't like the use of the timeout.
            //setTimeout(function () {
            //  context.ChangePerformanceLevelOrdinance(response)
            //}, 200)

            context.$notify({

              title: 'Success',

              message: 'Performance Level  created',

              type: 'success'

            })

          }, (error) => {

            loader.stopLoader()
            $('#Performancemodel').modal('hide')
            this.$notify({

              title: 'Error',

              message: error.responseJSON.Message,

              type: 'error'

            })
          })

        } else {
          this.$notify({

            title: 'Error',

            message: 'EVAL - 3 error while submit!!',

            type: 'error'

          })
          return false
        }
      })
    },

    submitEvaluation(formName) {
      let context = this

      this.$refs[formName].validate((valid) => {


        if (valid) {

          let context = this
          loader.startLoader()

          service.AddEvaluationType(context.AddEvaluationForm).then(function (response) {

            //Is this restricted ? -- FG - After Cert - First Release Security
            if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) { 
              loader.stopLoader()
              return;
            }

            loader.stopLoader()
            $('#AddEvaluatemodel').modal('hide')
            context.GetAllEvaluationTypes()

            //FG - FOOF - After Cert - First Release Security... I don't see the need
            //  for the call to ChangeEvaluationOrdiance here and it messes with
            //  security checks.... I especially don't like the use of the timeout.
            //setTimeout(function () {
            //  context.ChangeEvaluationTypeOrdinance(response) //WHY ??????? FOOF
            //}, 200)

            //context.GetAllEvaluationTypes()
            context.$notify({

              title: 'Success',

              message: 'Evaluation Type  created',

              type: 'success'

            })

          }, (error) => {

            loader.stopLoader()
            $('#AddEvaluatemodel').modal('hide')
            this.$notify({

              title: 'Error',

              message: error.responseJSON.Message,

              type: 'error'

            })
          })

        } else {
          this.$notify({

            title: 'Error',

            message: 'EVAL - 4 error while submit!!',

            type: 'error'

          })
          return false
        }
      })
    },

    resetForm(formName) {
      this.$refs[formName].resetFields()
    },

    //FG - FOOF - After Cert - First Release (6) - rewrote delete code below to use new methods in hydrowareCommonJS.js
    //The delete function below deletes a row from the table
    deleval(item){
      let context = this
      var ID = item.row.Id
      var opts = {message: 'Are you sure you want to delete ' + item.row.Name + '?'}
      context.$hydrowareCommonJS.displayConfirmDeletePopup(context, opts, context.deleteEvalRow.bind(null,ID))
    },
    deleteEvalRow(ID) {
      var context = this;
      loader.startLoader()

      service.DeleteEvaluationType(ID).then(function (response) {

        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) { 
          loader.stopLoader()
          return;
        }

        context.$hydrowareCommonJS.notifyDeleteSuccess(context);
        loader.stopLoader()
        for (var i = 0; i < context.evaluationtypes.length; i++) {
          if (context.evaluationtypes[i].Id == ID) {
            context.evaluationtypes.splice(i, 1)
          }
        }
        context.ChangeEvaluationTypeOrdinance('')
      }, (error) => {
        loader.stopLoader()
        context.$hydrowareCommonJS.notifyError(context,{message: error.responseJSON.Message})
      })
    },

   //FG - FOOF - After Cert - First Release (6) - rewrote delete code below to use new methods in hydrowareCommonJS.js
    //The delete function below deletes a row from the table
    delperf(item){
      let context = this
      var ID = item.row.Id
      var opts = {message: 'Are you sure you want to delete ' + item.row.Name + '?'}
      context.$hydrowareCommonJS.displayConfirmDeletePopup(context, opts, context.deletePerfRow.bind(null,ID))
    },
    deletePerfRow(ID) {
      var context = this;
      loader.startLoader()

      service.DeletePerformanceLevel(ID).then(function (response) {

        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) { 
          loader.stopLoader()
          return;
        }

        for (var i = 0; i < context.performancelevels.length; i++) {
          if (context.performancelevels[i].Id == ID) {
            context.performancelevels.splice(i, 1)
          }
        }
        context.ChangePerformanceLevelOrdinance('')
        context.$hydrowareCommonJS.notifyDeleteSuccess(context);
        loader.stopLoader()
      }, 
      (error) => {
        loader.stopLoader()
        context.$hydrowareCommonJS.notifyError(context,{message: error.responseJSON.Message})
      })
    },

    GetAllEvaluationTypes() {
      let context = this
      loader.startLoader()

      service.GetAllEvaluationTypes().then(function (response) {

        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {
          context.eordinance = []
          context.evaluationtypes = []   
          loader.stopLoader()
          return;
        }


        context.eordinance = []
        if (response) {
          context.evaluationtypes = response
          response.map(function (item, index) {
            context.eordinance.push(index + 1)
          })
          tooltip.startTooltip(50)
        } else {
          context.evaluationtypes = []
        }

        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.error_description,

          type: 'error'

        })
      })

    },

    GetAllPerformanceLevels() {
      let context = this
      context.pordinance = []
      loader.startLoader()
      service.GetAllPerformanceLevels().then(function (response) {

        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {
          context.performancelevels = []
          loader.stopLoader()
          return;
        }

        if (response) {
          context.performancelevels = response
          response.map(function (item, index) {
            context.pordinance.push(index + 1)
          })
          tooltip.startTooltip(50)
        } else {
          context.performancelevels = []
        }

        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.error_description,

          type: 'error'

        })
      })

    },

  }

}



// WEBPACK FOOTER //
// ./src/components/EvaluationManage/EvaluationManage.controller.js